module.exports = __webpack_public_path__ + "img/banner-tc2.c3d3c737.jpg";